module.exports = __webpack_public_path__ + "img/ui-success.9633ce24.svg";